export default __webpack_public_path__ + "static/homepage-hero-image-c25c973d3ad87325db1f08a21bd7227f.png";